import { Language, Lightning, Router, VideoPlayer } from '@lightningjs/sdk'
import { appSettings } from '../lib/AppSettings'
import ArtistCover from './coverItems/ArtistCover'
import RadioInfo from './coverItems/RadioInfo'
import VideoCover from './coverItems/VideoCover'

export default class RadioPageWrapper extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      x: 1920,

      // BackDrop: {w: 1920, h: 1080, src: ''},
      // Shade: {w: 1920, h: 1080, rect: true, alpha: 0.30, color: 0xff343434},
      VideoCover: { x: 1650, y: 406, w: 190, h: 229, type: VideoCover, visible: true },
      Artist: { x: 660, y: 425, mountX: 1, type: ArtistCover, signals: { CoverFocusDone: true } },
      RadioInfo: { x: 1070, y: 310, w: 580, h: 580, type: RadioInfo },
    }
  }

  set pageData(data) {
    const nowPlaying = data.nowPlaying,
      background = data.bg,
      currShow = data.currShow

    this._wrapper = data.wrapper.name
    this._autoPlay = data.autoPlay
    this._liveVideo = data.liveVideo

    this.tag('RadioInfo').infoData = currShow
    this.tag('Artist').item = { image: currShow.image, imageBg: background }
    this.tag('Artist').isCurrentyPlaying =
      VideoPlayer.src === appSettings.currentBrand.nationalStation.streamUrl
    if (this._liveVideo.type === 'video' && this._liveVideo.status !== 'inactive') {
      this.tag('VideoCover').video = nowPlaying.liveVideo
      this.tag('VideoCover').visible = true
    } else {
      this.tag('VideoCover').visible = false
    }
    this.signal('wrapperBuild', { wrapper: this._wrapper }) // to start Animation
    // this.tag('Artist').isCurrentyPlaying = currShow
    // this.tag("BackDrop").texture = Img(background).landscape(1920);
  }

  set isActiveWrapper(bool) {
    this._isActiveWrapper = bool

    this.tag('Artist').isOnActiveWrapper = bool
  }

  clear() {
    this._cleared = true
  }

  _init() {
    this._cleared = false
    // this.tag("BackDrop").on('txLoaded', () => {
    // 	this.signal("wrapperBuild", {wrapper: this._wrapper});
    // });
    // this.tag("BackDrop").on('txError', () => {
    // 	this.signal("wrapperBuild", {wrapper: this._wrapper});
    // })
  }
  onRadioMessage() {
    const data = appSettings.nowPlaying
    let start = new Date(Date.parse(data.currentShow.start)).toString()
    let finish = new Date(Date.parse(data.currentShow.finish)).toString()
    let now = new Date().toString()

    if (now > start && now < finish) {
      this.tag('RadioInfo').onAirShow = Language.translate('OnAir')
    } else {
      this.tag('RadioInfo').onAirShow = Language.translate('OnAirLive')
    }
    this.tag('Artist').onRadioMessage()
  }
  OnGpStateChange({ playbuttonState }) {
    this.tag('Artist').OnGpStateChange({ playbuttonState })
  }

  _focus() {
    this._setState('Artist')
  }

  _unfocus() {
    this._setState('Idle')
  }
  _inactive() {
    this.stage.gc()
  }
  _handlePlay() {
    if (
      !VideoPlayer.playing ||
      VideoPlayer.src !== appSettings.currentBrand.nationalStation.streamUrl
    ) {
      this._stationSelectTimeStamp = Date.now()
      this.widgets['globalplayer'].openNowPlaying(
        appSettings.currentBrand.nationalStation.heraldId,
        this._stationSelectTimeStamp
      )

      VideoPlayer.open(appSettings.currentBrand.nationalStation.streamUrl)
    }
  }

  _handleStop() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
  }

  static _states() {
    return [
      class Idle extends this {},

      class Artist extends this {
        $enter() {
          if (this._autoPlay) {
            this._handleEnter()
            this._autoPlay = false
          }
        }
        _handleRight() {
          if (this._liveVideo && this._liveVideo.status !== 'inactive') {
            this._setState('VideoCover')
          }
        }

        _handleEnter() {
          if (
            VideoPlayer.playing &&
            VideoPlayer.src !== null &&
            VideoPlayer.src === appSettings.currentBrand.nationalStation.streamUrl
          ) {
            VideoPlayer.close()
          } else {
            this._stationSelectTimeStamp = Date.now()
            this.widgets['globalplayer'].openNowPlaying(
              appSettings.currentBrand.nationalStation.heraldId,
              this._stationSelectTimeStamp
            )

            VideoPlayer.open(appSettings.currentBrand.nationalStation.streamUrl)
          }
        }

        _getFocused() {
          return this.tag('Artist')
        }
      },

      class VideoCover extends this {
        _handleEnter() {
          Router.navigate('liveVideo', { streamData: this._liveVideo })
        }

        _handleUp() {
          this._setState('TopMenu')
        }

        _handleLeft() {
          this._setState('Artist')
        }

        _getFocused() {
          return this.tag('VideoCover')
        }
      },
    ]
  }
}
